/**
 * Settings surfaces that used to follow the legacy admin role (#2429).
 *
 * Admin holds both by default. A workshop grants them from the role matrix
 * once the staff-api permission catalog lists the same ids.
 */
export const MANAGE_WHATSAPP_PERMISSION = 'settings.manage_whatsapp';
export const MANAGE_NUMBERING_PERMISSION = 'settings.manage_numbering';
